module.exports = __webpack_public_path__ + "c137931d85afbe2ee2fc78916def198c.svg";